<template>
  <Page>
    <WelcomeBanner v-if="ppmEnabled" />
    <QuickStartGuide
      :is-ppm-enabled="ppmEnabled"
    />
  </Page>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';
import { ProjectState } from '@/pages/app/project/api/get_project_state';
import Page from '@/pages/app/project/dashboard/components/page.vue';
import QuickStartGuide from '@/pages/app/project/dashboard/home/components/quick_start_guide.vue';
import WelcomeBanner from '@/pages/app/project/dashboard/home/components/welcome_banner.vue';

const projectState = inject<Ref<ProjectState>>('project') as Ref<ProjectState>;
const { ppmEnabled } = projectState.value.features;
</script>
